// extracted by mini-css-extract-plugin
export var actions = "_dt-g";
export var benefitCard = "_dt-b";
export var benefitIcon = "_dt-d";
export var benefitLabel = "_dt-f";
export var benefits = "_dt-a";
export var benefitsSection = "_dt-8";
export var bodyText = "_dt-7";
export var closeButton = "_dt-2";
export var content = "_dt-3";
export var eyebrow = "_dt-4";
export var heading = "_dt-5";
export var image = "_dt-i";
export var imagePanel = "_dt-h";
export var modal = "_dt-0";
export var offerCard = "_dt-c";
export var offerIcon = "_dt-e";
export var sectionLabel = "_dt-9";
export var shell = "_dt-1";
export var title = "_dt-6";